module.exports = "<app-workstep></app-workstep>\n"